import {Injectable} from "@angular/core";
import {RestangularModule, Restangular} from "ngx-restangular";

@Injectable()
export class EmployeesService {
  constructor(private restangular: Restangular) {
  }

  getAllEmployees() {
    return this.restangular.all("getAllEmployees");
  }

  getAllEmployeessuggest() {
    return this.restangular.all("getAllEmployeessuggest");
  }

  getAllEmployeessuggestProj() {
    return this.restangular.all("getAllEmployeessuggestProj");
  }

  getAllEmployeessuggestCourseReport() {
    return this.restangular.all("getAllEmployeessuggestCourseReport");
  }



  getAllEmployeesFormData() {
    return this.restangular.one("getAllEmployeesFormData");
  }

  getTemplateEmployeesFormData() {
    return this.restangular.one("getTemplateEmployeesFormData");
  }

  employeesCRUD() {
    return this.restangular.all("employeeMasterCRUD");
  }

  employeesDetailUD(id) {
    return this.restangular.all("employeeMasterCRUD/" + id);
  }

  employeePasswordReset() {
    return this.restangular.all("employeePasswordReset");
  }

  getAllFamilyDetails() {
    return this.restangular.one("getAllFamilyDetails");
  }

  employeeStoreTemplate() {
    return this.restangular.all("employeeStoreTemplate");
  }

  getSelectedEmployeeData() {
    return this.restangular.one("getSelectedEmployeeData");
  }

  updateTemplateEmployee() {
    return this.restangular.all("updateTemplateEmployee");
  }

  employeeFamilyDetailCRUD() {
    return this.restangular.all("employeeFamilyDetailsCRUD");
  }

  employeeFamilyDetailUD(id) {
    return this.restangular.all("employeeFamilyDetailsCRUD/" + id);
  }

  getTypeheadEmployees() {
    return this.restangular.one("getTypeheadEmployees");
  }

  getUserEmployeeList() {
    return this.restangular.one("getUserEmployeeList");
  }

  getEmployeeCoursesList() {
    return this.restangular.one("getEmployeeCoursesList");
  }

  getAllAssignmentsByEmployee() {
    return this.restangular.one("getAllAssignmentsByEmployee");
  }

  printEmployeePassport() {
    return this.restangular.one("printEmployeePassport");
  }

  employeeChangeEmailUpdate() {
    return this.restangular.all("employeeChangeEmailUpdate");
  }

  unblock() {
    return this.restangular.all("unblock");
  }

  adddocuments(){
    return this.restangular.all("adddocuments");
  }

  getEmployeeCoursesSummary() {
    return this.restangular.one("getEmployeeCoursesSummary");
  }

  getEmployeeCoursesCompetency() {
    return this.restangular.one("getEmployeeCoursesCompetency");
  }

  getAll() {
    return this.restangular.all("getAllEmployees");
  }

  deleteAllEmployeeMasterRecords() {
    return this.restangular.one("deleteAllEmployeeMasterRecords");
  }

  getEmployeesWithCovidVaccination() {
    return this.restangular.all("employeesVaccination");
  }

  getCovidDashboardData() {
    return this.restangular.all("getCovidDashboardData");
  }

  getRILRnptHoursReports() {
    return this.restangular.all("getRILRnptHoursReports");
  }

  getRilrNptHoursReportSummary() {
    return this.restangular.all("getRilrNptHoursReportSummary");
  }

  getTemplateAssignedRoute() {
    return this.restangular.one('getTemplateAssignedRoute');
  }

  jobInformationLR() {
    return this.restangular.one("jobInformationLR");
  }

  employeeAzureSync() {
    return this.restangular.one("syncADUsers");
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/employees.service.ts